<noda-large-card
  class="photo-card content-flex no-gap footer"
  [mediaMaxWidth]="enViewportSize.MD - 1"
  [mediaMinWidth]="enViewportSize.MD"
>
  <h4
    subtitle
    class="heading-4-v2"
  >
    <noda-translate [key]="subtitle()" />
  </h4>
  <h2
    title
    class="heading-2-v2 title"
  >
    <noda-translate [key]="title()" />
  </h2>
  @if (text()) {
    <p
      title
      class="text-2-v2--fade-color"
    >
      <noda-translate [key]="text()" />
    </p>
  }
  <noda-button-v2
    button
    class="button-start"
    [icon]="{ position: 'right', name: 'arrow_drop_right' }"
    [link]="buttonLink"
    [targetMethod]="'_self'"
    [text]="buttonText()"
  />
  <noda-image-card
    sub-content
    class="pre-footer-v2 inherit-border-radius"
    [haveExpandedSources]="false"
    [item]="currentImage()"
  />
</noda-large-card>
